require('./RANonresidentialModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

// @utilities
const { recordLink } = require('utilities/tagging');

class RANonresidentialModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    handleShowModal() {
        recordLink('modal inversiones no residentes', 'vista');
    }

    handleModalClose() {
        const { history, redirectionLink } = this.props;
        if (redirectionLink) {
            history.push(redirectionLink);
        }
        this.props.closeModal();
        recordLink('modal inversiones no residentes', 'salir');
    }

    render() {
        const { button, message, title } = this.props;
        return (
            <OKModal
                description={message}
                descriptionAlignment="center"
                footerType="action"
                isOpen={this.props.showModal}
                onAfterOpen={this.handleShowModal}
                onCloseCallback={this.handleModalClose}
                onPrimaryButtonClick={this.handleModalClose}
                primaryButtonText={button}
                shouldCloseOnOverlayClick={false}
                title={title}
                titleAlignment="center"
            />
        );
    }
}

RANonresidentialModal.propTypes = {
    history: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    number: PropTypes.string,
    redirectionLink: PropTypes.string,
};

module.exports = withRouter(RANonresidentialModal);
